
class GbUtils {
  
  /**
   * Валидирует британский VAT номер
   * @param {string} value - VAT для валидации
   * @returns {string|null} Ошибка валидации или null если корректный
   */
  static validateVAT(value) {
    if (typeof value !== 'string') return null;
    if (!/^GB(\d{9}(\d{3})?|[A-Z]{2}\d{3})$/g.test(value)) return 'Некорректный VAT';
    return null;
  }
}

export default GbUtils;